const overrideInsertElementWithReference = (editor, { insertElementWithReference }) => {
  editor.insertElementWithReference = insertElementWithReference;
};
export {
  overrideInsertElementWithReference
};
//# sourceMappingURL=overrideInsertElementWithReference.js.map
